<template>
  <div>
    <JadeListItem
      compact
      v-for="(option, index) in options"
      :key="`jade-list-item-selection-${index}`"
      class="jade-list-item-selection"
      as="label"
      :label="option.label"
      :for="`input-${index}`"
      @onClick="handleSelect(option)"
      :data-testid="`jade-list-item-${index}`"
    >
      <template #trailing>
        <div class="jade-list-item-selection__trailing">
          <component
            name="option"
            :is="component"
            :value.sync="option.selected"
            :supportText="option.description"
            :id="`input-${index}`"
          />
        </div>
      </template>
    </JadeListItem>
  </div>
</template>
<script>
import JadeListItem from '@jade/JadeListItem'
import { TYPE_ENUM } from '../enums/dropdown-selection-type.enum.js'

export default {
  name: 'JadeListItemSelection',
  components: {
    JadeListItem
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      required: true,
      validation: t => [TYPE_ENUM.SINGLE, TYPE_ENUM.MULTI].includes(t)
    }
  },
  computed: {
    component () {
      const map = {
        [TYPE_ENUM.MULTI]: () => import('@jade/JadeCheckbox'),
        [TYPE_ENUM.SINGLE]: () => import('@jade/JadeRadioButton')
      }

      return map[this.type]
    }
  },
  methods: {
    handleSelect (option) {
      this.$emit('onOptionChange', { ...option })
    }
  }
}
</script>
<style scoped>
/**
 * Estilos extraídos do '@stone-payments/jade/css/list-item-selection.css' devido a um problema de compatibilidade
 * O problema está em análise pelo time do jade
 */
.jade,
.jade.stone {
  --comp-list-item-min-height: 40px;
  --comp-list-item-gap-x: 12px;
  --comp-list-item-corner-radius: var(--theme-corner-radius-interactive, 8px);
  --comp-list-item-margin-y: 4px;
  --comp-list-item-margin-x: 8px;
  --comp-list-item-padding-left: 12px;
  --comp-list-item-padding-right: 8px;
  --comp-list-item-padding-y: 8px;
  --comp-list-item-leading-min-width: 20px;
  --comp-list-item-trailing-padding-right: 4px;
  --comp-list-item-is-compact-min-height: 28px;
  --comp-list-item-is-compact-padding-y: 4px;
  --comp-list-item-is-compact-margin-y: 2px;
  --comp-list-item-main-content-gap-y: 2px;
  --comp-list-item-main-content-label-gap-x: 4px;
  --comp-list-item-hover-background: var(
    --theme-color-background-surface-hover,
    hsla(210, 98.8%, 14.4%, 0.055)
  );
  --comp-list-item-danger-hover-background: var(
    --theme-color-background-negative-subtle-hover,
    hsla(0, 100%, 50%, 0.102)
  );
  --comp-list-item-is-active-background: var(
    --theme-color-background-brand-subtle,
    hsla(139, 100%, 32%, 0.1)
  );
  --comp-list-item-is-active-hover-background: var(
    --theme-color-background-brand-subtle-hover,
    hsla(140, 100%, 33%, 0.16)
  );
  --comp-list-item-is-selection-trailing-gap-x: 8px;
  --comp-list-item-is-selection-checked-background: var(
    --theme-color-background-brand-subtle,
    hsla(139, 100%, 32%, 0.1)
  );
  --comp-list-item-is-selection-checked-hover-background: var(
    --theme-color-background-brand-subtle-hover,
    hsla(140, 100%, 33%, 0.16)
  );
  --comp-list-item-focus-outline-width: var(--theme-focus-outline-width, 2px);
  --comp-list-item-focus-outline-style: var(--theme-focus-outline-style, solid);
  --comp-list-item-focus-outline-color: var(
    --theme-focus-outline-color,
    hsla(214, 16%, 20%, 0.84)
  );
  --comp-list-item-focus-outline-offset: var(--theme-focus-outline-offset, 2px);
}

.jade-list-item-selection__trailing {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--comp-list-item-is-selection-trailing-gap-x);
}
.jade-list-item-selection:has(input:focus-visible) {
  outline: var(--comp-list-item-focus-outline-width)
    var(--comp-list-item-focus-outline-style)
    var(--comp-list-item-focus-outline-color);
  outline-offset: var(--comp-list-item-focus-outline-offset);
}

.jade-list-item-selection:has(input:checked) {
  background: var(--comp-list-item-is-selection-checked-background);
}
.jade-list-item-selection:has(input:checked):hover {
  background: var(--comp-list-item-is-selection-checked-hover-background);
}
</style>
